import type {
  UseFilePickerConfig,
  useImperativeFilePickerConfig,
  FilePickerReturnTypes,
  ImperativeFilePickerReturnTypes,
  ExtractContentTypeFromConfig,
} from 'use-file-picker/types';
import {
  useFilePicker as useOriginalFilePicker,
  useImperativeFilePicker as useOriginalImperativeFilePicker,
} from 'use-file-picker';

// export all types from use-file-picker
export type * from 'use-file-picker/types';

// export validators from use-file-picker
export {
  FileAmountLimitValidator,
  FileTypeValidator,
  FileSizeValidator,
  ImageDimensionsValidator,
  PersistentFileAmountLimitValidator,
} from 'use-file-picker/validators';

/**
 * Hook that wraps `useFilePicker` from the use-file-picker library
 *
 * @param config Optional configuration for the file picker
 */
export const useFilePicker = <T extends UseFilePickerConfig = UseFilePickerConfig>(
  config: T = {} as T,
): FilePickerReturnTypes<ExtractContentTypeFromConfig<T>> => {
  const finalConfig = {
    readFilesContent: false,
    ...config,
  } as T;

  return useOriginalFilePicker(finalConfig);
};

/**
 * Hook that wraps `useImperativeFilePicker` from the use-file-picker library
 *
 * @param config Optional configuration for the imperative file picker
 */
export const useImperativeFilePicker = <
  T extends useImperativeFilePickerConfig = useImperativeFilePickerConfig,
>(
  config: T = {} as T,
): ImperativeFilePickerReturnTypes<ExtractContentTypeFromConfig<T>> => {
  const finalConfig = {
    readFilesContent: false,
    ...config,
  } as T;

  return useOriginalImperativeFilePicker(finalConfig);
};
